import React from "react";
import Modal from '../modal/modal.component';

export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: false
		};
	}
	componentDidCatch(err, errInfo) {
		if(window.uiLogging) {
			let error = {
				message : err.stack
			}
			window.uiLogging.logException(error);
		}
		this.setState({
			error: true
		});
	}

	render() {
		if (this.state.error) {
			return (
					<Modal type="CUSTOM" show={this.state.error}>
						<div className="modal-content">
							<div className="modal-header">
								<h4>We're sorry</h4>
							</div>
							<div className="modal-body">
								<p>An unexpected error has occurred. Our technical staff has been automatically notified and will be looking into this with utmost urgency.</p>
							</div>
							<div className="modal-footer">
							</div>
						</div>
					</Modal>
			);
		}
		return this.props.children;
	}
}